<div    class   =   "w-100 h-100 d-flex justify-content-between"
        *ngIf   =   "formCtrl">
    <div    class   =   "d-flex justify-content-center align-items-end w-100"
            *ngIf   =   "isManaged()">
        <ng-container [ngSwitch]="fileExtension()">
            <cq-image-preview  *ngSwitchCase="'png'"    [file]    =   "formCtrl.value"></cq-image-preview>
            <cq-image-preview  *ngSwitchCase="'jpg'"    [file]    =   "formCtrl.value"></cq-image-preview>
            <cq-image-preview  *ngSwitchCase="'jpeg'"   [file]    =   "formCtrl.value"></cq-image-preview>
            <cq-image-preview  *ngSwitchCase="'gif'"   [file]    =   "formCtrl.value"></cq-image-preview>
        </ng-container>
    </div>
    <!-- 
    <div    class   =   "d-flex justify-content-center align-items-end w-100">
        <span   class   =   "limited-text">
            {{ getFileName() }}
        </span>
    </div>
    -->
</div>